export default __webpack_public_path__ + "static/media/Highlord's Cloak of Cinders.69b3cfdf.jpg";